const BACKDROP_SPINNER = 'modal-backdrop--spinner';
let rotation = 0;
let spinnerInterval = null;

export function loadSpinner(message = 'Loading') {
    let $body = $('body');
    const $announcer = $('#loading-announcer');
    $announcer.text('');
    // added svg for now to fix testcases failing
    // need to find a new spinner for light fontawesome
    let spinner = `<div class="modal-backdrop fade show ${BACKDROP_SPINNER}">
    <i class="fal fa-spinner isa-spinner fa-spin" aria-hidden="true"></i>
    </div>`;
    $announcer.text(message);
    $body.append(spinner);
    window.spinnerActive = true;
    rotateSpinner();
}

export function stopSpinner(message = 'loading completed') {
    clearInterval(spinnerInterval);
    let $modalSpinner = $(`.${BACKDROP_SPINNER}`);
    $modalSpinner.remove();
    rotation = 0;
    spinnerInterval = null;
    window.spinnerActive = false;
    const $announcer = $('#loading-announcer');
    $announcer.text('');
    $announcer.text(message);
}

export function startLoadingSpinner(container) {
    let spinner = `<div class="isa-spinner isa-spinner--loading"><i class="fal fa-spinner fa-circle-notch fa-spin isa-spinner__icon" role="status" aria-hidden="true"></i></div>`;
    container.append(spinner);
}

export function stopLoadingSpinner(container) {
    let spinner = $('.isa-spinner--loading');
    container.find(spinner).remove();
}

function rotateSpinner() {
    try {
        let spinner = $(`.${BACKDROP_SPINNER}`);
        if(!spinner.length) {
            console.warn('Spinner backdrop not found.');
            return;
        }
        spinnerInterval = setInterval(() => {
            try {
                rotation = (rotation + 5) % 360;
                let isaSpinner = spinner.find('.isa-spinner');
                if(isaSpinner.length) {
                    isaSpinner.css('transform', `rotate(${rotation}deg)`);
                } else {
                    clearInterval(spinnerInterval);
                }
            } catch (innerErr) {
                console.error('Error during spinner rotation:', innerErr);
                clearInterval(spinnerInterval);
            }
        }, 50);
    } catch (err) {
        console.error('Error initializing spinner rotation:', err);
    }
}

export function showSpinner(message = 'Loading') {
    if(window.spinnerActive) return;
    loadSpinner(message);
}

export function hideSpinner(message = 'loading completed') {
    if(!window.spinnerActive) return;
    stopSpinner(message);
}
